/* import __COLOCATED_TEMPLATE__ from './posting-results-list.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

import { APPLICATION } from 'sh-www/models/application';

const CLASS_NAME = 'SH-c-posting-results-list';

/** @module */
class AdminPostingResultsListComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get isPending() {
    return this.args.applicationSimpleStatusFilter === APPLICATION.SIMPLE_STATUS.PENDING;
  }

  get isHired() {
    return this.args.applicationSimpleStatusFilter === APPLICATION.SIMPLE_STATUS.HIRED;
  }

  get isDeclined() {
    return this.args.applicationSimpleStatusFilter === APPLICATION.SIMPLE_STATUS.DECLINED;
  }

  get noResultsMessage() {
    switch(this.args.applicationSimpleStatusFilter) {
      case APPLICATION.SIMPLE_STATUS.PENDING:
        return [
          'No pending proposals',
          'Proposals that are neither accepted nor declined will appear here.',
        ];
      case APPLICATION.SIMPLE_STATUS.HIRED: 
        return [
          'Nobody hired yet',
          'Proposals that are accepted will appear here.',
        ];
      case APPLICATION.SIMPLE_STATUS.DECLINED:
        return [
          'No declined proposals',
          'Proposals that are declined will appear here.',
        ];
      default:
        return [];
    }
  }
}

export default AdminPostingResultsListComponent;
